import { render, staticRenderFns } from "./RevisionRequested.vue?vue&type=template&id=4ec5d1b6"
import script from "./RevisionRequested.vue?vue&type=script&lang=js"
export * from "./RevisionRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports